// Source-of-truth for the `size-*` dimension scale — the curated 4pt token scale
// (`--rc-size-*`, 12–80px) used to size elements (icon / avatar / control widths &
// heights) to consistent dimensions. Distinct from `space-*` (spacing); step numbers
// mirror it (`size-6` == `space-6` == 24px).
//
// Each step N maps to the `--rc-size-N` token and to the utility classes
// `.width-size-N` / `.height-size-N` (+ responsive `tablet-` / `mobile-` variants). Kept
// in lock-step with global/size.tokens.js and the generator in
// classes-utility/width-and-height.scss via the drift-guard test. Rebuild all.css after
// editing the SCSS (npm run build-styles).

export const SIZE_STEPS = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 20] as const;

export type SizeStep = typeof SIZE_STEPS[number];

// A size step → its width/height utility class at one breakpoint (`prefix` is `''` for the
// base and `tablet-` / `mobile-` otherwise).
export function sizeClass(dimension: 'width' | 'height', step: SizeStep, prefix = ''): string {
  return `${prefix}${dimension}-size-${step}`;
}
